<template>
  <!-- 添加编辑弹窗 -->
  <el-dialog
    title="二级分类"
    :visible.sync="categoryShow"
    width="800px"
    class="firstChild"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div class="diabox">
      <el-form :model="info" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="上级分类">{{ info.p_category_name }}</el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="info.sort"
            step-strictly
            :step="1"
            :min="0"
            :max="1000000000"
            :controls="false"
            placeholder="请输入排序"
          ></el-input-number>
          <span style="margin-left: 10px; color: #999"
            >数字越大，排名越靠前,如果为空，默认排序方式为创建时间</span
          >
        </el-form-item>

        <el-form-item label="分类名称" prop="category_name">
          <el-input
            v-model="info.category_name"
            maxlength="20"
            style="width: 280px"
            placeholder="不超过20个字"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-radio v-model="info.is_visible" :label="1">是</el-radio>
          <el-radio v-model="info.is_visible" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="分类logo" prop="category_pic">
          <el-upload
            name="image"
            accept=".png,.jpeg,.jpg"
            :show-file-list="false"
            :http-request="uploadImg"
            action="category_pic"
          >
            <el-button slot="trigger" type="text">上传本地图片</el-button>

            <el-button
              style="margin-left: 10px"
              type="text"
              @click="chooseHistoryImg(1)"
              >选择历史图片</el-button
            >
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >尽量上传方形图片，大小在5MB以内，支持png,jpeg,jpg格式，最多可上传1张</span
            >
          </el-upload>
        </el-form-item>
        <div class="box" v-show="info.category_pic">
          <img :src="info.category_pic_str" />

          <el-upload
            :show-file-list="false"
            :http-request="uploadImg"
            action="category_pic"
          >
            <div class="shadow column-center column">
              <div>
                <i
                  class="el-icon-search"
                  @click.stop="showImg(info.category_pic_str)"
                ></i>

                <i class="el-icon-delete" @click.stop="delImg(1)"></i>
              </div>
            </div>
          </el-upload>
        </div>
      </el-form>
    </div>
    <div style="text-align: right; padding: 0 50px 20px 0">
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="close" style="width: 92px"
          >取消</el-button
        >
        <el-button type="primary" @click="submit" style="width: 92px"
          >保 存</el-button
        >
      </span>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
    <!-- //历史图片 -->
    <HistoryImg
      v-if="historyImgShow"
      @chooseImg="chooseImg"
      :type="historyType"
      @close="historyImgShow = false"
    ></HistoryImg>
  </el-dialog>
</template>

<script>
import HistoryImg from './HistoryImg';
import { uploadImg, getImgUrl } from '../../../service/common/constant';
export default {
  name: 'firstChild',
  data() {
    return {
      categoryShow: true,
      info: {
        sort: undefined,
        category_name: '',
        is_visible: 1,
        category_pic: '',
        category_pic_str: ''
      },
      rules: {
        category_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ],
        category_pic: [
          { required: true, message: '请上传分类图片', trigger: 'blur' }
        ]
      },
      imgList: [],
      showViewer: false,
      historyImgShow: false,
      historyType: '' //历史图片选择的类型
    };
  },
  props: {
    oldInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {
    'el-image-viewer': () =>
      import('element-ui/packages/image/src/image-viewer'),
    HistoryImg
  },
  created() {
    this.info = {
      p_category_name: this.oldInfo.p_category_name || '',
      p_category_id: this.oldInfo.p_category_id || '',
      category_id: this.oldInfo.category_id || '',
      sort: this.oldInfo.sort || undefined,
      category_name: this.oldInfo.category_name || '',
      is_visible: this.oldInfo.is_visible == 0 ? 0 : 1,
      category_pic: this.oldInfo.category_pic || '',
      category_pic_str: this.oldInfo.category_pic_str || ''
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    //上传图片
    uploadImg(params, item) {
      let file = params.file;
      uploadImg(file)
        .then((res) => {
          if (params.action == 'category_pic') {
            this.info.category_pic = res.data.pic;
            this.info.category_pic_str = res.data.path;
          } else if (params.action == 'category_banner') {
            this.info.category_banner = res.data.path;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //前往选择历史图片
    chooseHistoryImg(type) {
      this.historyType = type;
      this.historyImgShow = true;
    },
    chooseImg(item) {
      if (this.historyType == 1) {
        this.info.category_pic = item.pic_url;
        this.info.category_pic_str = item.pic_url_str;
      } else if (this.historyType == 2) {
        this.info.category_banner = item.pic_url;
      }
      this.historyImgShow = false;
    },
    //查看图片
    showImg(item) {
      this.imgList = [item];
      this.showViewer = true;
    },
    //删除图片
    delImg(type) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          if (type == 1) {
            this.info.category_pic = '';
            this.info.category_pic_str = '';
          } else if (type == 2) {
            this.info.category_banner = '';
          }
          // let list = type == 1 ? this.form.img_id_array : this.form.description;
          // list.splice(
          //   list.findIndex((ele) => item == ele),
          //   1
          // );
        })
        .catch(() => {});
    },
    submit() {
      let check = false;
      this.$refs.ruleForm.validate((valid) => {
        check = valid;
      });
      if (!check) {
        return;
      }
      let data = {
        pid: this.info.p_category_id,
        sort: this.info.sort || 0,
        category_name: this.info.category_name,
        is_visible: this.info.is_visible,
        category_pic: this.info.category_pic
      };
      let url = '';
      if (this.info.category_id) {
        url = 'platform/ManageGoods/editCategoryInfo';
        data.category_id = this.info.category_id;
      } else {
        url = 'platform/ManageGoods/saveSecondCategoryInfo';
      }
      this.axios.post(url, data).then((res) => {
        this.$message.success('操作成功');
        this.$parent.getList();
        this.close();
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.diabox {
  padding: 20px 20px 0;
  overflow: auto;
  max-height: 60vh;
}
.uploadimg {
  width: 200px;
  height: 200px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  box-sizing: border-box;
  .avatar {
    width: 200px;
    height: 200px;
  }
  .icobox {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
.tip {
  color: #999;
  margin: 15px 0;
}
.box {
  position: relative;
  padding-left: 100px;
  &:hover .shadow {
    display: flex;
  }
  img {
    width: 200px;
    height: 200px;
  }
  .shadow {
    position: absolute;
    left: 100px;
    top: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.firstChild {
  .el-input-number input {
    text-align: left !important;
  }
}
</style>
